"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get isArray () {
        return isArray;
    },
    get isBoolean () {
        return isBoolean;
    },
    get isDate () {
        return isDate;
    },
    get isNamedReference () {
        return isNamedReference;
    },
    get isRecord () {
        return isRecord;
    },
    get isString () {
        return isString;
    },
    get isSummarizeByReference () {
        return isSummarizeByReference;
    },
    get isUserReference () {
        return isUserReference;
    },
    get isValidISODate () {
        return isValidISODate;
    },
    get isValidJSONString () {
        return isValidJSONString;
    },
    get isValidObjectID () {
        return isValidObjectID;
    },
    get validObjectID () {
        return validObjectID;
    }
});
const _bson = require("bson");
const _datefns = require("date-fns");
const isString = (value)=>{
    return typeof value === "string";
};
const isBoolean = (value)=>{
    return typeof value === "boolean";
};
const isArray = (value)=>{
    return Array.isArray(value);
};
const isDate = (value)=>{
    return value instanceof Date;
};
const isRecord = (value)=>{
    if (typeof value !== "object" || value === null || isArray(value)) {
        return false;
    }
    return true;
};
const isValidObjectID = (value)=>{
    return validObjectID(value);
};
const isValidISODate = (value)=>{
    return (0, _datefns.isValid)((0, _datefns.parseISO)(value));
};
const isValidJSONString = (value)=>{
    try {
        JSON.parse(value);
        return true;
    } catch (e) {
        return false;
    }
};
const isUserReference = (item)=>{
    if (!isRecord(item)) {
        return false;
    }
    if (item._id === undefined || item.name === undefined || item.email === undefined) {
        return false;
    }
    return true;
};
const isNamedReference = (item)=>{
    if (!isRecord(item)) {
        return false;
    }
    if (item.name === undefined) {
        return false;
    }
    return true;
};
const isSummarizeByReference = (item)=>{
    if (!isRecord(item)) {
        return false;
    }
    if (item._id === undefined || item.name === undefined) {
        return false;
    }
    return true;
};
const validObjectID = (valueToCheck)=>{
    // Check if valueToCheck is of the types compatible with ObjectId
    if (typeof valueToCheck !== "string" && typeof valueToCheck !== "number" && !(valueToCheck instanceof _bson.ObjectId) && !(valueToCheck instanceof Buffer) && !(valueToCheck instanceof Uint8Array)) {
        return false;
    }
    // if isValid() is false, we can be sure it is not a valid mongo ObjectId
    if (!_bson.ObjectId.isValid(valueToCheck)) {
        return false;
    }
    // However, isValid() will return true for any input
    // that is str of length 12 or number, so we must check.
    // ObjectId().toString() should be idempotent if operating on a valid
    // mongo ObjectId or a string representation of a valid ObjectId,
    // but not if operating on a number or random string of length 12
    const inputAsObjectID = new _bson.ObjectId(valueToCheck);
    if (inputAsObjectID.toString() !== valueToCheck.toString()) {
        return false;
    }
    return true;
};
